import { updateAnalyticsTaskHistoryMetric } from '@process-advisor/process-miner/processMiner/processMiner';

export type AnalyticTaskMetricProps = {
    metric?: number;
}

export const changeAnalyticsTaskHistoryMetric = ({
    metric,
}: AnalyticTaskMetricProps) => updateAnalyticsTaskHistoryMetric({
    metric,
});
